var warnBeforeClosing = true;


var CheckUser = function () {
    var self = this;
    self.name = ko.observable('');
    self.training = ko.observable('');
    self.company = ko.observable("");
    self.companyId = ko.observable("");
    self.startdate = ko.observable("");
    self.email = ko.observable("");
    self.guid = ko.observable(guid);
    self.trainingId = ko.observable('');

    self.getDatePart = function (date) {
        var tdate = new Date(LogosObjectWrapper.dateFromLogosDate(date));
        return tdate.getDate() + "/" + (tdate.getMonth() + 1) + "/" + tdate.getFullYear();
    };


    self.loading = ko.observable(false);

    self.loading.subscribe(function (value) {

        if (value) {
            $("#loading").fadeIn();
        } else {
            $("#loading").fadeOut();
        }
    });


    self.loading(true);

    self.logosservice = new LogosInfrontService("", "dGJydXluZWVs", "dGVzdHBhc3dvb3Jk");
    self.logosservice.getSucscription(this.guid(), function (inschrijving) {
        //console.log(inschrijving);

        self.loading(true);
        self.logosservice.getContact(inschrijving.getValueForKey("new_deelnemerid").Id, function (contact) {
            //  console.log(contact);
            var langcode = contact.getValueForKey("new_taal");
            var userLang = langcode && langcode.Value.toString() === "100000000" ? "nl" : "fr";
            var alreadyEntered = inschrijving.getValueForKey("new_evaluatieformulierontvangenop") ? true : false;
            // console.log(inschrijving.getValueForKey("new_evaluatieformulierontvangenop"));
            if (alreadyEntered) {
                warnBeforeClosing = false;
                window.location = "index.php?lang=" + userLang + "&action=already_submitted";
            } else if (lang !== userLang) {
                 warnBeforeClosing = false;
                window.location = "index.php?lang=" + userLang;
            }


            self.email(contact.getValueForKey("emailaddress1"));




            self.name(contact.getValueForKey("fullname"));
            self.training(inschrijving.getValueForKey("new_opleidingid").Name);
            self.trainingId(inschrijving.getValueForKey("new_opleidingid").Id);
            self.company(contact.getValueForKey("parentcustomerid").Name);
            self.companyId(contact.getValueForKey("parentcustomerid").Id);
            self.startdate(self.getDatePart(inschrijving.getValueForKey("new_opleidingsstartdatum")));
            self.loading(false);

        });


    });


};



var AskEmail = function () {
    var self = this;
    CheckUser.apply(self);
    $("#checkEmailBtn").click(function (e) {
        e.preventDefault();
        if (self.email().toLowerCase() === $("#form_input_email").val().toLowerCase()) {
            $("#form_submit_email").submit();
        }
    });


    jQuery.validator.addMethod("emailEqual", function (value, element) {
        return value.toLowerCase() === self.email().toLowerCase();
    }, "Please check your email");

    $("#form_input_email").rules("add", {
        emailEqual: true
    });

};

var FormVM = function () {
    var self = this;

    CheckUser.apply(self);
    //pt1
    self.form_part1_question1 = ko.observable(1);
    self.form_part1_question2 = ko.observable(1);
    self.form_part1_question3 = ko.observable(1);
    self.form_part1_question4 = ko.observable(1);
    self.form_part1_question5 = ko.observable(1);
    self.form_part1_question6 = ko.observable("");
    self.form_part1_question7 = ko.observable("");
    self.form_part1_question8 = ko.observable("");



    //pt2
    self.form_part2_question1 = ko.observable(1);
    self.form_part2_question2 = ko.observable(1);
    self.form_part2_question3 = ko.observable(1);
    self.form_part2_question4 = ko.observable(1);
    self.form_part2_question5 = ko.observable(1);
    self.form_part2_question6 = ko.observable(1);
    self.form_part2_question7 = ko.observable(1);
    self.form_part2_question8 = ko.observable(1);
    self.form_part2_question9 = ko.observable("");


    //pt3
    self.form_part3_question1 = ko.observable(1);
    self.form_part3_question2 = ko.observable(1);
    self.form_part3_question3 = ko.observable(1);
    self.form_part3_question4 = ko.observable(1);
    self.form_part3_question5 = ko.observable(1);
    self.form_part3_question6 = ko.observable("");




    $("#formSubmitBtn").click(function (e) {
        e.preventDefault();
        self.submitForm();
    });

    self.submitForm = function () {

        self.loading(true);
        var fields = [


        //pt 1
              {
              key: "new_inschrijvingid",
              value: {
                  __type: "EntityReference:http://schemas.microsoft.com/xrm/2011/Contracts",
                  Id: self.guid(),
                  LogicalName: "new_inschrijving"
              }
          },

             {
                 key: "new_opleidingid",
                 value: {
                     __type: "EntityReference:http://schemas.microsoft.com/xrm/2011/Contracts",
                     Id: self.trainingId(),
                     LogicalName: "new_opleiding"
                 }
             },

            { key: "new_hoeveelheidthemas", value: parseInt(self.form_part1_question1()) },
            { key: "new_hoeveelheidoefeningen", value: parseInt(self.form_part1_question2()) },
            { key: "new_moeilijkheidsgraad", value: parseInt(self.form_part1_question3()) },
            { key: "new_toepasbaarheidindepraktijk", value: parseInt(self.form_part1_question4()) },
            { key: "new_beantwoordtaanverwachtingen", value: parseInt(self.form_part1_question5()) },
            { key: "new_welkethemaszullenjehetmeestebijblijven", value: self.form_part1_question6() },
            { key: "new_welkethemasvondjeminderinteressant", value: self.form_part1_question7() },
            { key: "new_opmerkingeninhoud", value: self.form_part1_question8() },

        //pt2
            {key: "new_vakkennistrainer", value: parseInt(self.form_part2_question1()) },
            { key: "new_kwaliteitvandekennisoverdracht", value: parseInt(self.form_part2_question2()) },
            { key: "new_structuurenopbouwvandeopleiding", value: parseInt(self.form_part2_question3()) },
            { key: "new_duidelijkheidvandeuitleg", value: parseInt(self.form_part2_question4()) },
            { key: "new_tempovanlesgeven", value: parseInt(self.form_part2_question5()) },
            { key: "new_inspelenopvragen", value: parseInt(self.form_part2_question6()) },
            { key: "new_omgangmetdedeelnemers", value: parseInt(self.form_part2_question7()) },
            { key: "new_dynamismeenenthousiasme", value: parseInt(self.form_part2_question8()) },
            { key: "new_opmerkingentrainer", value: self.form_part2_question9() },


        //pt3
            {key: "new_praktischeinfovoordestart", value: parseInt(self.form_part3_question1()) },
            { key: "new_lesmateriaal", value: parseInt(self.form_part3_question2()) },
            { key: "new_onthaal", value: parseInt(self.form_part3_question3()) },
            { key: "new_leslokaal", value: parseInt(self.form_part3_question4()) },
            { key: "new_drankenlunch", value: parseInt(self.form_part3_question5()) },
            { key: "new_opmerkingenpraktischeorganisatie", value: self.form_part3_question6() },


        ];

       // console.log(fields);

        // submit
        // on success: redirect

        self.logosservice.submitEvaluation(self.guid(), fields, function (resp) {
       
            warnBeforeClosing = false;
            document.location = "index.php?action=thanks";
        });
    };
};



function getUrlVars() {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}



$(document).ready(function () {
    var page = $("body").data("page");


    if (page && page === "request_email") {
        $("#form_submit_email").validate();
        ko.applyBindings(new AskEmail());
    } else if (page && page === "form") {
        $("input[type=range]").styleSlider();
        setTimeout(function () {
            $(".form_part").not(".open").addClass("closed");
        }, 500);

        setTimeout(function () {
            $(".label_slider").each(function () {
                var line = $(this).closest(".row");
                var height = $(this).height();
                if (height > 25) {
                    $(line).addClass("double");
                }
            });
        }, 1000);

        $("#logosform").validate();

        $("a.btn-next").click(function (e) {
            e.preventDefault();
              var nowpart = $(this).closest(".form_part");
            var nextpart = nowpart.data("part") + 1;
            $(".form_part").removeClass("open").addClass("closed");

            var element = $("#form_part_" + nextpart);
            element.removeClass("closed").addClass("open");
           
                $("html, body").animate({ scrollTop: nowpart.offset().top + 60 }, 500);

           

        });

        $("a.btn-prev").click(function (e) {
            e.preventDefault();
            var nowpart = $(this).closest(".form_part");
            var prevpart = nowpart.data("part") - 1;
            $(".form_part").removeClass("open").addClass("closed");
            var element = $("#form_part_" + prevpart);
            element.removeClass("closed").addClass("open");

            $("html, body").animate({ scrollTop: element.offset().top - 25}, 500);


        });

        window.onbeforeunload = function () {
            if (warnBeforeClosing) {
                return formCloseInfo;
            }
        };

        ko.applyBindings(new FormVM());

    }
});
